<template>
  <div>
    <a
      href="#"
      class="btn btn-light-facebook btn-sm px-4 custom-btn text-no-wrap"
      @click="toggleModal"
      >View</a
    >
    <div>
      <v-dialog
        v-model="dialog"
        persistent
        transition="dialog-bottom-transition"
        max-width="850"
      >
        <!--begin::Modal dialog-->
        <div class="bg-white poppins">
          <!--begin::Modal header-->
          <div class="modal-header py-4 align-center">
            <h4 class="mb-0 font-weight-bolder">Shipment Logs</h4>
            <!--begin::Close-->
            <div
              class="btn btn-sm btn-icon btn-active-light-info"
              @click="dialog = false"
            >
              <span class="svg-icon">
                <v-icon size="22">mdi-close</v-icon>
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body mx-5 mx-xl-15 py-4">
            <!--begin::Body-->
            <div v-if="loading" class="d-flex justify-content-center py-10">
              <v-progress-circular :size="40" :width="6" indeterminate />
            </div>
            <div v-else-if="message" class="text-center py-6 font-weight-bold">
              {{ message }}
            </div>
            <template v-else-if="tabs.length">
              <v-tabs v-model="activeTab" light>
                <v-tab v-for="tab in tabs" :key="tab.title">{{
                  tab.title
                }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="activeTab">
                <v-tab-item v-for="tab in tabs" :key="tab.title">
                  <div class="h-500px scroll-y py-4">
                    <json-view :data="tab.value" />
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </template>
            <!--end::Body-->
          </div>
          <!--end::Modal body-->
        </div>
        <!--end::Modal dialog-->
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "ExternalRequestDetails",
  props: ["header", "value", "item", "module"],
  data: () => ({
    dialog: false,
    loading: false,
    tabs: [],
    message: null,
    activeTab: 0,
  }),
  methods: {
    toggleModal() {
      if (!this.dialog) {
        this.tabs = [];
        this.message = null;
        this.activeTab = 0;
        this.loadServerData();
      } else this.dialog = !this.dialog;
    },
    loadServerData() {
      this.$store.commit(SET_PAGE_LOADING, true);
      this.loading = true;
      const endpointMap = {
        pickupOrders: "shipping/pickup_orders/show_shipment_logs",
        returns: "shipping/returns_management/show_shipment_logs",
      };
      const endpoint = endpointMap[this.module];
      ApiService.post(endpoint, {
        id: this.item.id,
      })
        .then((response) => {
          const data = response.data;
          if (!data.success) {
            // this.message = data.message || "An error occurred.";
            this.dialog = false;
          } else if (!data.has_json_payload) {
            this.message = data.detail || "Not found.";
            this.dialog = true;
          } else {
            this.dialog = true;
            this.tabs = data.detail;
          }
        })
        .catch(() => {
          this.message = "Failed to load data.";
        })
        .finally(() => {
          this.loading = false;
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>
